export default "__VITE_ASSET__5dvbhubg__"